import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Stack
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { setOpenSnackbar } from '../../../store/slices/snackbarSlice';
import useVrackApi from '../../../hooks/useVrackApi';

const defaultCompany = 'pac';

AddTeamDialog.propTypes = {
  isOpen: PropTypes.bool,
  closeHandler: PropTypes.func,
  updateTeams: PropTypes.func
};

export default function AddTeamDialog({ isOpen, closeHandler, updateTeams }) {
  const [teamName, setTeamName] = useState('');
  const [teamError, setTeamError] = useState('');
  const [company, setCompany] = useState(defaultCompany);
  const [projectCode, setProjectCode] = useState('');

  const dispatch = useDispatch();
  const openSnackbar = (payload) => dispatch(setOpenSnackbar(payload));

  const { fetchData: addTeamApi } = useVrackApi('post', '/admin/teams');

  const validateTeamName = (name) => {
    if (!name) {
      setTeamError('Team name is required');
      return false;
    }
    if (!name.endsWith('_team')) {
      setTeamError('Team name must end with "_team"');
      return false;
    }
    setTeamError('');
    return true;
  };

  const handleTeamChange = (event) => {
    const { value } = event.target;
    setTeamName(value);
    validateTeamName(value);
  };

  const handleCompanyChange = (event) => {
    setCompany(event.target.value);
  };

  const handleCodeChange = (event) => {
    setProjectCode(event.target.value);
  };

  const handleClose = () => {
    // clear fields when closed
    setCompany(defaultCompany);
    setProjectCode('');
    closeHandler();
  };

  const handleAdd = async () => {
    if (!validateTeamName(teamName)) return;
    const reqBody = [{ team_name: teamName, company, project_code: projectCode }];
    console.debug(`Adding team: ${teamName}`);
    try {
      const response = await addTeamApi({ data: reqBody });
      console.debug(`successfully added team: ${JSON.stringify(response)}`);
      openSnackbar({ message: 'Added team successfully!' });
      updateTeams();
      handleClose();
    } catch {
      openSnackbar({ message: 'Failed to add team', severity: 'error' });
      handleClose();
    }
  };

  return (
    <Dialog open={isOpen}>
      <DialogTitle>Add Team</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <DialogContentText>Create a new VRack Team</DialogContentText>
          <TextField
            autoFocus
            onChange={handleTeamChange}
            error={!!teamError}
            required
            id="team"
            label="Team Name"
            fullWidth
            variant="outlined"
            helperText={teamError || "Enter the team name (ensure name ends with '_team')"}
            inputProps={{ maxLength: 100 }}
          />
          <TextField
            onChange={handleCompanyChange}
            required
            id="company"
            label="Company"
            fullWidth
            variant="outlined"
            defaultValue="pac"
            helperText="Associated Company"
          />
          <TextField
            onChange={handleCodeChange}
            required
            id="cost_code"
            label="Project / Cost Code"
            fullWidth
            variant="outlined"
            helperText="the project or cost code that is associated to the team"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleAdd}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
